import { Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { MockService } from '@mock/mock.service';
import { loginMockData } from '@mock/data/auth-mock.data';
import { ILogin, ILoginResponse, IResetPassword, ISubmitNewPassword, ITwofa } from '@app/api/interfaces/auth.interface';

@Injectable({ providedIn: 'root' })
export class AuthMockService extends MockService {
  public login(requestData: ILogin): Observable<ILoginResponse> {
    return this.mockResponse('AUTH:login', loginMockData).pipe(delay(this.requestDelay));
  }

  public twofa(requestData: ITwofa): Observable<ILoginResponse> {
    return this.mockResponse('AUTH:twofa', loginMockData).pipe(delay(this.requestDelay));
  }

  public doResetPassword(requestData: IResetPassword): Observable<object> {
    return this.mockResponse('AUTH:doResetPassword', {}).pipe(delay(this.requestDelay));
  }

  public doSubmitResetPassword(requestData: ISubmitNewPassword): Observable<object> {
    return this.mockResponse('AUTH:doSubmitResetPassword', {}).pipe(delay(this.requestDelay));
  }

  public logout(): Observable<object> {
    return this.mockResponse('AUTH:logout', {}).pipe(delay(this.requestDelay));
  }
}
